import { useReactiveVar } from '@apollo/client'
import GridItem from '@deltek/specification-client/core/Surfaces/GridItem'
import clsx from 'clsx'
import { processEnv } from 'components/configuration/environmentVariables'
import React, { FC, useCallback, useMemo } from 'react'
import { PREMIUM_PLUS } from './AddNewProductModal'
import { AutoCompleteInput } from './AutoCompleteInput'
import {
    addProductDialogState,
    defaultAddProductDialogState,
    setProductDialogState,
} from './addProductFormHandler'
import { useAddProductFormStyles } from './formStyles'

const ListingTypeAutoCompleteInput: FC = () => {
    const classes = useAddProductFormStyles()

    const isBadgelessCardsEnabled = processEnv.REACT_APP_EnableBadgelessCards === '1'

    const ListingLevelOptions = [
        isBadgelessCardsEnabled
            ? {
                  display: 'Product Listing',
                  value: 'productListing',
              }
            : {
                  display: PREMIUM_PLUS,
                  value: 'premiumPlus',
              },
        ...(!isBadgelessCardsEnabled
            ? [{ display: 'Premium Proprietary', value: 'premiumProprietary' }]
            : []),
    ]

    const listingTypeOptions = useMemo(() => {
        return ListingLevelOptions.map((ll) => ll.display)
    }, [ListingLevelOptions])

    const { type, errors } = useReactiveVar(addProductDialogState)

    const handleChange = useCallback(
        (_, value) => {
            setProductDialogState({
                ...defaultAddProductDialogState,
                type: value,
            })
        },
        [setProductDialogState, defaultAddProductDialogState]
    )

    const handleInputChange = useCallback(() => {}, [])

    return (
        <GridItem
            className={clsx(
                classes.rowContainer,
                classes.smallContainer,
                'rowContainer'
            )}
            xs={7}
            data-testid="type"
        >
            <AutoCompleteInput
                name="Choose Listing Type"
                handleChange={handleChange}
                valid={!errors.type}
                handleInputChange={handleInputChange}
                selectedValue={type}
                items={listingTypeOptions}
                getOptionSelected={(option, value) => option === value}
            />
        </GridItem>
    )
}

export default ListingTypeAutoCompleteInput
